import { Component, OnInit } from '@angular/core';
import { first } from 'rxjs/operators';
import { Task } from '@app/_components/task';
import { TaskService } from '@app/_components/task';
import { AlertService, AuthenticationService } from '@app/_services';
import { Router } from '@angular/router';
import { SelectItem, LazyLoadEvent } from 'primeng/api';

@Component({
    selector: 'app-maintenance-list',
    templateUrl: './maintenance-list.component.html',
    styleUrls: ['./maintenance-list.component.css'],
    standalone: false
})
export class MaintenanceListComponent implements OnInit
{
	datasource: Task[];
	task: Task;
	tasks: Task[] = [];
	columns: any[];
	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;
	taskStatusOptions: SelectItem[];



	constructor(
		private authenticationService: AuthenticationService,
		private taskService: TaskService,
		private alertService: AlertService,
		private router: Router
	) { }


	ngOnInit()
	{
		try
		{
			this.columns = [
				{ field: 'taskId', header: 'Id' },
				{ field: 'status', header: 'Status' },
				{ field: 'firstName', header: 'First' },
				{ field: 'lastName', header: 'Last' },
				{ field: 'email', header: 'Email' },
				{ field: 'lastLogin', header: 'Login' }
			];

			this.taskStatusOptions = [
				{ label: 'Active', value: 'A' },
				{ label: 'Suspended', value: 'S' },
				{ label: 'Canceled', value: 'C' }
			];

		} catch (error)
		{
			console.log('ngOnInit() ' + error);
		}
	}

	loadLazy(event: LazyLoadEvent)
	{
		try
		{
			this.loading = true;
			this.lazyLoadEvent = event;

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);

			const pageNumber = Math.round(event.first / event.rows);
			this.taskService.findByFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(

					apiResponse =>
					{
						console.log('tasks are: ' + JSON.stringify(apiResponse));
						this.datasource = apiResponse.data.tasks;
						this.recordTotal = apiResponse.page.recordTotal;
						this.tasks = apiResponse.data.tasks;
					},
					apiResponse =>
					{
						console.log('USER LIST!: ' + JSON.stringify(apiResponse));
						this.alertService.error(apiResponse);
					},
					() =>
					{ this.loading = false; }
				);

			if (this.datasource)
			{
				this.tasks = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error)
		{
			console.log('loadLazy(' + event + ')' + error);
		}
	}
	onRowSelect(event)
	{
		try
		{
			// use this for adding query params
			// this.router.navigate(['task-edit'], { queryParams: { taskId: event.data.taskId } });
			this.router.navigate(['task-view', event.data.taskId]);
		} catch (error)
		{
			console.log('onRowSelect(' + event + ')' + error);
		}
	}
}
